module.exports = __webpack_public_path__ + "img/icon-gen-ai-gradient.6ede364b.svg";